// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar {
  position: fixed !important;
  top: 0;
  overflow: hidden;
  bottom: 0;
  z-index: 1032;
  width: 210px;
  cursor: default;
  -moz-user-select: -moz-none;
  user-select: none;
  border-left: none;
  border-right: 1px solid transparent;
  -webkit-transform: translate3d(-210px, 0px, 0px);
  transform: translate3d(-210px, 0px, 0px);
  max-width: 220px;
}
.sidebar.sidebar-ready {
  -webkit-transition: -webkit-transform 0.05s;
  transition: transform 0.05s;
}
.sidebar.sidebar-open {
  -webkit-transform: translate3d(0px, 0px, 0px);
  transform: translate3d(0px, 0px, 0px);
}
.sidebar .sidebar-menu {
  margin: 0;
  padding: 0;
  overflow-x: hidden;
  overflow-y: hidden;
  height: 100%;
  list-style: none;
  text-align: left;
  font-size: 14px;
}
.sidebar .sidebar-menu ul {
  padding: 0;
  margin: 0;
}
.sidebar .sidebar-menu li {
  display: block;
}
.sidebar .sidebar-menu,
.sidebar .sidebar-menu ul,
.sidebar .sidebar-menu li,
.sidebar .sidebar-menu span,
.sidebar .sidebar-menu a {
  touch-action: pan-y;
}
.sidebar.sidebar-ready .sidebar-menu {
  overflow-y: auto;
}
.sidebar .sidebar-group > span,
.sidebar .sidebar-item > a {
  display: block;
  height: 100%;
  padding: 8px 15px;
  text-decoration: none;
  position: relative;
}
.sidebar .sidebar-group > span:empty,
.sidebar .sidebar-item > a:empty {
  padding: 0;
}
.sidebar .sidebar-item > a.active {
  border-left: 5px solid;
  padding: 12px 15px 12px 10px;
}
.sidebar .sidebar-item.sidebar-item-mini {
  font-size: 0.85em;
}
.sidebar .sidebar-item.sidebar-item-mini > a {
  padding-top: 12px;
  padding-bottom: 12px;
}
.sidebar .sidebar-group > span {
  font-family: inherit;
  font-size: 24px;
  border-top: 1px solid transparent;
}
.sidebar .sidebar-group > span.no-bar {
  border-top: none;
}
.sidebar .sidebar-group.sticky-header {
  position: absolute;
  height: auto;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1;
  margin-top: 0;
}
.sidebar .sidebar-group + .sidebar-item {
  margin-top: 32px;
  border-top: 1px solid transparent;
}
.sidebar .sidebar-divider-item {
  border-top: 1px solid transparent;
}
.sidebar .sidebar-item > a {
  cursor: pointer;
}
.sidebar-swipe {
  position: fixed;
  z-index: 1031;
  width: 10px;
  left: 0;
  top: 0;
  bottom: 0;
  -moz-user-select: -moz-none;
  user-select: none;
}
.sidebar-disabled + .sidebar-swipe {
  display: none;
}
.sidebar-open + .sidebar-swipe,
.sidebar-force-open + .sidebar-swipe {
  left: 210px;
}
.sidebar-obfuscator {
  position: inherit;
  display: block;
  z-index: -1;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  opacity: 0;
  -webkit-transition: opacity 0.3s ease, z-index 0s linear 0.3s;
  -o-transition: opacity 0.3s ease, z-index 0s linear 0.3s;
  transition: opacity 0.3s ease, z-index 0s linear 0.3s;
}
.sidebar-open ~ .sidebar-obfuscator {
  -webkit-transition: opacity 0.3s ease;
  -o-transition: opacity 0.3s ease;
  transition: opacity 0.3s ease;
  z-index: 1031;
  opacity: 1;
  position: fixed;
}
.sidebar-right.sidebar {
  right: 0;
  border-right: none;
  border-left: 1px solid transparent;
  -webkit-transform: translate3d(210px, 0px, 0px);
  transform: translate3d(210px, 0px, 0px);
}
.sidebar-right.sidebar.sidebar-open {
  -webkit-transform: translate3d(0px, 0px, 0px);
  transform: translate3d(0px, 0px, 0px);
}
.sidebar-right.sidebar .sidebar-item > a.active {
  border-left: inherit;
  border-right: 5px solid;
  padding: 12px 10px 12px 15px;
}
.sidebar-right + .sidebar-swipe {
  left: auto;
  right: 0;
}
.sidebar-right.sidebar-open + .sidebar-swipe,
.sidebar-right.sidebar-force-open + .sidebar-swipe {
  right: 210px;
}
.sidebar.sidebar-default.sidebar-open,
.sidebar.sidebar-default.sidebar-dragging {
  -webkit-box-shadow: 3px 0 4px rgba(0, 0, 0, 0.18);
  box-shadow: 3px 0 4px rgba(0, 0, 0, 0.18);
}
.sidebar.sidebar-inverse.sidebar-open,
.sidebar.sidebar-inverse.sidebar-dragging {
  -webkit-box-shadow: 3px 0 4px rgba(0, 0, 0, 0.32);
  box-shadow: 3px 0 4px rgba(0, 0, 0, 0.32);
}
.sidebar-right.sidebar.sidebar-default.sidebar-open,
.sidebar-right.sidebar.sidebar-default.sidebar-dragging {
  -webkit-box-shadow: -3px 0 4px rgba(0, 0, 0, 0.18);
  box-shadow: -3px 0 4px rgba(0, 0, 0, 0.18);
}
.sidebar-right.sidebar.sidebar-inverse.sidebar-open,
.sidebar-right.sidebar.sidebar-inverse.sidebar-dragging {
  -webkit-box-shadow: -3px 0 4px rgba(0, 0, 0, 0.32);
  box-shadow: -3px 0 4px rgba(0, 0, 0, 0.32);
}
@media (max-width: 767px) {
  .sidebar {
    width: 80%;
    -webkit-transform: translate3d(-100%, 0px, 0px);
    transform: translate3d(-100%, 0px, 0px);
  }
  .sidebar-open + .sidebar-open {
    max-width: 220px;
  }
  .sidebar-open + .sidebar-swipe,
  .sidebar-force-open.sidebar-open + .sidebar-swipe {
    left: 80%;
  }
  .sidebar-force-open + .sidebar-swipe {
    left: 0;
  }
  .sidebar-right.sidebar {
    -webkit-transform: translate3d(100%, 0px, 0px);
    transform: translate3d(100%, 0px, 0px);
  }
  .sidebar-right.sidebar-open + .sidebar-swipe {
    left: auto;
    right: 80%;
  }
  .sidebar-right.sidebar-force-open + .sidebar-swipe {
    left: auto;
    right: 0;
  }
}
@media (max-width: 991px) {
  .sidebar-open + .sidebar-open {
    max-width: 220px;
  }
  .sidebar-force-open.sidebar:not(.sidebar-open) + .sidebar-swipe {
    left: 0;
  }
}
@media (min-width: 992px) {
  .sidebar-open + .sidebar-open {
    max-width: 220px;
  }
  .sidebar.sidebar-open-init {
    -webkit-transform: translate3d(0px, 0px, 0px);
    transform: translate3d(0px, 0px, 0px);
  }
  .sidebar-force-open.sidebar.sidebar-default.sidebar-open,
  .sidebar-force-open.sidebar.sidebar-default.sidebar-dragging {
    -webkit-box-shadow: none;
    box-shadow: none;
  }
  .sidebar-force-open.sidebar.sidebar-inverse.sidebar-open,
  .sidebar-force-open.sidebar.sidebar-inverse.sidebar-dragging {
    -webkit-box-shadow: none;
    box-shadow: none;
  }
  .sidebar-force-open.sidebar-right.sidebar.sidebar-default.sidebar-open,
  .sidebar-force-open.sidebar-right.sidebar.sidebar-default.sidebar-dragging {
    -webkit-box-shadow: none;
    box-shadow: none;
  }
  .sidebar-force-open.sidebar-right.sidebar.sidebar-inverse.sidebar-open,
  .sidebar-force-open.sidebar-right.sidebar.sidebar-inverse.sidebar-dragging {
    -webkit-box-shadow: none;
    box-shadow: none;
  }
}
@media (max-width: 991px) {
  .sidebar,
  .sidebar-swipe {
    top: 0 !important;
    bottom: 0 !important;
  }
}
.sidebar {
  -ms-touch-action: none;
}
.sidebar-swipe {
  -ms-touch-action: none;
}
.sidebar-menu,
.sidebar-menu ul,
.sidebar-menu li,
.sidebar-menu span,
.sidebar-menu a {
  -ms-touch-action: pan-y;
}
.sidebar.sidebar-default {
  color: #222222;
  background-color: #fff;
}
.sidebar.sidebar-default .sidebar-group > span {
  color: #dbdbdb;
  border-top-color: #eeeeee;
}
.sidebar.sidebar-default .sidebar-group.sticky-header > span {
  background-color: #fff;
}
.sidebar.sidebar-default .sidebar-group + .sidebar-item {
  border-top-color: #eeeeee;
}
.sidebar.sidebar-default .sidebar-divider-item {
  border-top-color: #eeeeee;
}
.sidebar.sidebar-default .sidebar-item > a {
  color: #222222;
  background-color: transprent;
}
.sidebar.sidebar-default .sidebar-item > a:hover,
.sidebar.sidebar-default .sidebar-item > a:focus {
  color: #333;
  background-color: #eeeeee;
}
.sidebar.sidebar-default .sidebar-item > a.active {
  color: #337ab7;
  background-color: transprent;
}
.sidebar.sidebar-default .sidebar-item.sidebar-item-mini > a {
  color: #464646;
}
.sidebar.sidebar-default .hammer-scrollbar {
  background-color: #555;
}
.sidebar.sidebar-inverse {
  color: #9d9d9d;
  background-color: #2a3542;
}
.sidebar.sidebar-inverse .sidebar-group > span {
  color: #46586e;
  border-top-color: #344252;
}
.sidebar.sidebar-inverse .sidebar-group.sticky-header > span {
  background-color: #2a3542;
}
.sidebar.sidebar-inverse .sidebar-group + .sidebar-item {
  border-top-color: #344252;
}
.sidebar.sidebar-inverse .sidebar-divider-item {
  border-top-color: #344252;
}
.sidebar.sidebar-inverse .sidebar-item > a {
  color: #9d9d9d;
  background-color: #2a3542;
}
.sidebar.sidebar-inverse .sidebar-item > a:hover,
.sidebar.sidebar-inverse .sidebar-item > a:focus {
  color: #fff;
  background-color: #344252;
}
.sidebar.sidebar-inverse .sidebar-item > a.active {
  color: #dfecf6;
  background-color: #2a3542;
}
.sidebar.sidebar-inverse .sidebar-item.sidebar-item-mini > a {
  color: #c1c1c1;
}
.sidebar.sidebar-inverse .hammer-scrollbar {
  background-color: #e4e8ed;
}
.sidebar-obfuscator {
  background-color: rgba(0, 0, 0, 0.5);
}
@media (min-width: 992px) {
  .sidebar.sidebar-locked.sidebar-default {
    border-color: #eeeeee;
    max-width: 220px;
  }
  .sidebar.sidebar-locked.sidebar-inverse {
    border-color: #344252;
  }
}
`, "",{"version":3,"sources":["webpack://./assets/sonatra-jquery-sidebar/css/sidebar.css"],"names":[],"mappings":"AAAA;EACE,0BAA0B;EAC1B,MAAM;EACN,gBAAgB;EAChB,SAAS;EACT,aAAa;EACb,YAAY;EACZ,eAAe;EACf,2BAA2B;EAC3B,iBAAiB;EACjB,iBAAiB;EACjB,mCAAmC;EACnC,gDAAgD;EAChD,wCAAwC;EACxC,gBAAgB;AAClB;AACA;EACE,2CAA2C;EAC3C,2BAA2B;AAC7B;AACA;EACE,6CAA6C;EAC7C,qCAAqC;AACvC;AACA;EACE,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,UAAU;EACV,SAAS;AACX;AACA;EACE,cAAc;AAChB;AACA;;;;;EAKE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;;EAEE,cAAc;EACd,YAAY;EACZ,iBAAiB;EACjB,qBAAqB;EACrB,kBAAkB;AACpB;AACA;;EAEE,UAAU;AACZ;AACA;EACE,sBAAsB;EACtB,4BAA4B;AAC9B;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,oBAAoB;EACpB,eAAe;EACf,iCAAiC;AACnC;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,MAAM;EACN,OAAO;EACP,QAAQ;EACR,UAAU;EACV,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,aAAa;EACb,WAAW;EACX,OAAO;EACP,MAAM;EACN,SAAS;EACT,2BAA2B;EAC3B,iBAAiB;AACnB;AACA;EACE,aAAa;AACf;AACA;;EAEE,WAAW;AACb;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,WAAW;EACX,MAAM;EACN,SAAS;EACT,OAAO;EACP,QAAQ;EACR,UAAU;EACV,6DAA6D;EAC7D,wDAAwD;EACxD,qDAAqD;AACvD;AACA;EACE,qCAAqC;EACrC,gCAAgC;EAChC,6BAA6B;EAC7B,aAAa;EACb,UAAU;EACV,eAAe;AACjB;AACA;EACE,QAAQ;EACR,kBAAkB;EAClB,kCAAkC;EAClC,+CAA+C;EAC/C,uCAAuC;AACzC;AACA;EACE,6CAA6C;EAC7C,qCAAqC;AACvC;AACA;EACE,oBAAoB;EACpB,uBAAuB;EACvB,4BAA4B;AAC9B;AACA;EACE,UAAU;EACV,QAAQ;AACV;AACA;;EAEE,YAAY;AACd;AACA;;EAEE,iDAAiD;EACjD,yCAAyC;AAC3C;AACA;;EAEE,iDAAiD;EACjD,yCAAyC;AAC3C;AACA;;EAEE,kDAAkD;EAClD,0CAA0C;AAC5C;AACA;;EAEE,kDAAkD;EAClD,0CAA0C;AAC5C;AACA;EACE;IACE,UAAU;IACV,+CAA+C;IAC/C,uCAAuC;EACzC;EACA;IACE,gBAAgB;EAClB;EACA;;IAEE,SAAS;EACX;EACA;IACE,OAAO;EACT;EACA;IACE,8CAA8C;IAC9C,sCAAsC;EACxC;EACA;IACE,UAAU;IACV,UAAU;EACZ;EACA;IACE,UAAU;IACV,QAAQ;EACV;AACF;AACA;EACE;IACE,gBAAgB;EAClB;EACA;IACE,OAAO;EACT;AACF;AACA;EACE;IACE,gBAAgB;EAClB;EACA;IACE,6CAA6C;IAC7C,qCAAqC;EACvC;EACA;;IAEE,wBAAwB;IACxB,gBAAgB;EAClB;EACA;;IAEE,wBAAwB;IACxB,gBAAgB;EAClB;EACA;;IAEE,wBAAwB;IACxB,gBAAgB;EAClB;EACA;;IAEE,wBAAwB;IACxB,gBAAgB;EAClB;AACF;AACA;EACE;;IAEE,iBAAiB;IACjB,oBAAoB;EACtB;AACF;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;;;;;EAKE,uBAAuB;AACzB;AACA;EACE,cAAc;EACd,sBAAsB;AACxB;AACA;EACE,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,sBAAsB;AACxB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,4BAA4B;AAC9B;AACA;;EAEE,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,4BAA4B;AAC9B;AACA;EACE,cAAc;AAChB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,yBAAyB;AAC3B;AACA;;EAEE,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,oCAAoC;AACtC;AACA;EACE;IACE,qBAAqB;IACrB,gBAAgB;EAClB;EACA;IACE,qBAAqB;EACvB;AACF","sourcesContent":[".sidebar {\r\n  position: fixed !important;\r\n  top: 0;\r\n  overflow: hidden;\r\n  bottom: 0;\r\n  z-index: 1032;\r\n  width: 210px;\r\n  cursor: default;\r\n  -moz-user-select: -moz-none;\r\n  user-select: none;\r\n  border-left: none;\r\n  border-right: 1px solid transparent;\r\n  -webkit-transform: translate3d(-210px, 0px, 0px);\r\n  transform: translate3d(-210px, 0px, 0px);\r\n  max-width: 220px;\r\n}\r\n.sidebar.sidebar-ready {\r\n  -webkit-transition: -webkit-transform 0.05s;\r\n  transition: transform 0.05s;\r\n}\r\n.sidebar.sidebar-open {\r\n  -webkit-transform: translate3d(0px, 0px, 0px);\r\n  transform: translate3d(0px, 0px, 0px);\r\n}\r\n.sidebar .sidebar-menu {\r\n  margin: 0;\r\n  padding: 0;\r\n  overflow-x: hidden;\r\n  overflow-y: hidden;\r\n  height: 100%;\r\n  list-style: none;\r\n  text-align: left;\r\n  font-size: 14px;\r\n}\r\n.sidebar .sidebar-menu ul {\r\n  padding: 0;\r\n  margin: 0;\r\n}\r\n.sidebar .sidebar-menu li {\r\n  display: block;\r\n}\r\n.sidebar .sidebar-menu,\r\n.sidebar .sidebar-menu ul,\r\n.sidebar .sidebar-menu li,\r\n.sidebar .sidebar-menu span,\r\n.sidebar .sidebar-menu a {\r\n  touch-action: pan-y;\r\n}\r\n.sidebar.sidebar-ready .sidebar-menu {\r\n  overflow-y: auto;\r\n}\r\n.sidebar .sidebar-group > span,\r\n.sidebar .sidebar-item > a {\r\n  display: block;\r\n  height: 100%;\r\n  padding: 8px 15px;\r\n  text-decoration: none;\r\n  position: relative;\r\n}\r\n.sidebar .sidebar-group > span:empty,\r\n.sidebar .sidebar-item > a:empty {\r\n  padding: 0;\r\n}\r\n.sidebar .sidebar-item > a.active {\r\n  border-left: 5px solid;\r\n  padding: 12px 15px 12px 10px;\r\n}\r\n.sidebar .sidebar-item.sidebar-item-mini {\r\n  font-size: 0.85em;\r\n}\r\n.sidebar .sidebar-item.sidebar-item-mini > a {\r\n  padding-top: 12px;\r\n  padding-bottom: 12px;\r\n}\r\n.sidebar .sidebar-group > span {\r\n  font-family: inherit;\r\n  font-size: 24px;\r\n  border-top: 1px solid transparent;\r\n}\r\n.sidebar .sidebar-group > span.no-bar {\r\n  border-top: none;\r\n}\r\n.sidebar .sidebar-group.sticky-header {\r\n  position: absolute;\r\n  height: auto;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  z-index: 1;\r\n  margin-top: 0;\r\n}\r\n.sidebar .sidebar-group + .sidebar-item {\r\n  margin-top: 32px;\r\n  border-top: 1px solid transparent;\r\n}\r\n.sidebar .sidebar-divider-item {\r\n  border-top: 1px solid transparent;\r\n}\r\n.sidebar .sidebar-item > a {\r\n  cursor: pointer;\r\n}\r\n.sidebar-swipe {\r\n  position: fixed;\r\n  z-index: 1031;\r\n  width: 10px;\r\n  left: 0;\r\n  top: 0;\r\n  bottom: 0;\r\n  -moz-user-select: -moz-none;\r\n  user-select: none;\r\n}\r\n.sidebar-disabled + .sidebar-swipe {\r\n  display: none;\r\n}\r\n.sidebar-open + .sidebar-swipe,\r\n.sidebar-force-open + .sidebar-swipe {\r\n  left: 210px;\r\n}\r\n.sidebar-obfuscator {\r\n  position: inherit;\r\n  display: block;\r\n  z-index: -1;\r\n  top: 0;\r\n  bottom: 0;\r\n  left: 0;\r\n  right: 0;\r\n  opacity: 0;\r\n  -webkit-transition: opacity 0.3s ease, z-index 0s linear 0.3s;\r\n  -o-transition: opacity 0.3s ease, z-index 0s linear 0.3s;\r\n  transition: opacity 0.3s ease, z-index 0s linear 0.3s;\r\n}\r\n.sidebar-open ~ .sidebar-obfuscator {\r\n  -webkit-transition: opacity 0.3s ease;\r\n  -o-transition: opacity 0.3s ease;\r\n  transition: opacity 0.3s ease;\r\n  z-index: 1031;\r\n  opacity: 1;\r\n  position: fixed;\r\n}\r\n.sidebar-right.sidebar {\r\n  right: 0;\r\n  border-right: none;\r\n  border-left: 1px solid transparent;\r\n  -webkit-transform: translate3d(210px, 0px, 0px);\r\n  transform: translate3d(210px, 0px, 0px);\r\n}\r\n.sidebar-right.sidebar.sidebar-open {\r\n  -webkit-transform: translate3d(0px, 0px, 0px);\r\n  transform: translate3d(0px, 0px, 0px);\r\n}\r\n.sidebar-right.sidebar .sidebar-item > a.active {\r\n  border-left: inherit;\r\n  border-right: 5px solid;\r\n  padding: 12px 10px 12px 15px;\r\n}\r\n.sidebar-right + .sidebar-swipe {\r\n  left: auto;\r\n  right: 0;\r\n}\r\n.sidebar-right.sidebar-open + .sidebar-swipe,\r\n.sidebar-right.sidebar-force-open + .sidebar-swipe {\r\n  right: 210px;\r\n}\r\n.sidebar.sidebar-default.sidebar-open,\r\n.sidebar.sidebar-default.sidebar-dragging {\r\n  -webkit-box-shadow: 3px 0 4px rgba(0, 0, 0, 0.18);\r\n  box-shadow: 3px 0 4px rgba(0, 0, 0, 0.18);\r\n}\r\n.sidebar.sidebar-inverse.sidebar-open,\r\n.sidebar.sidebar-inverse.sidebar-dragging {\r\n  -webkit-box-shadow: 3px 0 4px rgba(0, 0, 0, 0.32);\r\n  box-shadow: 3px 0 4px rgba(0, 0, 0, 0.32);\r\n}\r\n.sidebar-right.sidebar.sidebar-default.sidebar-open,\r\n.sidebar-right.sidebar.sidebar-default.sidebar-dragging {\r\n  -webkit-box-shadow: -3px 0 4px rgba(0, 0, 0, 0.18);\r\n  box-shadow: -3px 0 4px rgba(0, 0, 0, 0.18);\r\n}\r\n.sidebar-right.sidebar.sidebar-inverse.sidebar-open,\r\n.sidebar-right.sidebar.sidebar-inverse.sidebar-dragging {\r\n  -webkit-box-shadow: -3px 0 4px rgba(0, 0, 0, 0.32);\r\n  box-shadow: -3px 0 4px rgba(0, 0, 0, 0.32);\r\n}\r\n@media (max-width: 767px) {\r\n  .sidebar {\r\n    width: 80%;\r\n    -webkit-transform: translate3d(-100%, 0px, 0px);\r\n    transform: translate3d(-100%, 0px, 0px);\r\n  }\r\n  .sidebar-open + .sidebar-open {\r\n    max-width: 220px;\r\n  }\r\n  .sidebar-open + .sidebar-swipe,\r\n  .sidebar-force-open.sidebar-open + .sidebar-swipe {\r\n    left: 80%;\r\n  }\r\n  .sidebar-force-open + .sidebar-swipe {\r\n    left: 0;\r\n  }\r\n  .sidebar-right.sidebar {\r\n    -webkit-transform: translate3d(100%, 0px, 0px);\r\n    transform: translate3d(100%, 0px, 0px);\r\n  }\r\n  .sidebar-right.sidebar-open + .sidebar-swipe {\r\n    left: auto;\r\n    right: 80%;\r\n  }\r\n  .sidebar-right.sidebar-force-open + .sidebar-swipe {\r\n    left: auto;\r\n    right: 0;\r\n  }\r\n}\r\n@media (max-width: 991px) {\r\n  .sidebar-open + .sidebar-open {\r\n    max-width: 220px;\r\n  }\r\n  .sidebar-force-open.sidebar:not(.sidebar-open) + .sidebar-swipe {\r\n    left: 0;\r\n  }\r\n}\r\n@media (min-width: 992px) {\r\n  .sidebar-open + .sidebar-open {\r\n    max-width: 220px;\r\n  }\r\n  .sidebar.sidebar-open-init {\r\n    -webkit-transform: translate3d(0px, 0px, 0px);\r\n    transform: translate3d(0px, 0px, 0px);\r\n  }\r\n  .sidebar-force-open.sidebar.sidebar-default.sidebar-open,\r\n  .sidebar-force-open.sidebar.sidebar-default.sidebar-dragging {\r\n    -webkit-box-shadow: none;\r\n    box-shadow: none;\r\n  }\r\n  .sidebar-force-open.sidebar.sidebar-inverse.sidebar-open,\r\n  .sidebar-force-open.sidebar.sidebar-inverse.sidebar-dragging {\r\n    -webkit-box-shadow: none;\r\n    box-shadow: none;\r\n  }\r\n  .sidebar-force-open.sidebar-right.sidebar.sidebar-default.sidebar-open,\r\n  .sidebar-force-open.sidebar-right.sidebar.sidebar-default.sidebar-dragging {\r\n    -webkit-box-shadow: none;\r\n    box-shadow: none;\r\n  }\r\n  .sidebar-force-open.sidebar-right.sidebar.sidebar-inverse.sidebar-open,\r\n  .sidebar-force-open.sidebar-right.sidebar.sidebar-inverse.sidebar-dragging {\r\n    -webkit-box-shadow: none;\r\n    box-shadow: none;\r\n  }\r\n}\r\n@media (max-width: 991px) {\r\n  .sidebar,\r\n  .sidebar-swipe {\r\n    top: 0 !important;\r\n    bottom: 0 !important;\r\n  }\r\n}\r\n.sidebar {\r\n  -ms-touch-action: none;\r\n}\r\n.sidebar-swipe {\r\n  -ms-touch-action: none;\r\n}\r\n.sidebar-menu,\r\n.sidebar-menu ul,\r\n.sidebar-menu li,\r\n.sidebar-menu span,\r\n.sidebar-menu a {\r\n  -ms-touch-action: pan-y;\r\n}\r\n.sidebar.sidebar-default {\r\n  color: #222222;\r\n  background-color: #fff;\r\n}\r\n.sidebar.sidebar-default .sidebar-group > span {\r\n  color: #dbdbdb;\r\n  border-top-color: #eeeeee;\r\n}\r\n.sidebar.sidebar-default .sidebar-group.sticky-header > span {\r\n  background-color: #fff;\r\n}\r\n.sidebar.sidebar-default .sidebar-group + .sidebar-item {\r\n  border-top-color: #eeeeee;\r\n}\r\n.sidebar.sidebar-default .sidebar-divider-item {\r\n  border-top-color: #eeeeee;\r\n}\r\n.sidebar.sidebar-default .sidebar-item > a {\r\n  color: #222222;\r\n  background-color: transprent;\r\n}\r\n.sidebar.sidebar-default .sidebar-item > a:hover,\r\n.sidebar.sidebar-default .sidebar-item > a:focus {\r\n  color: #333;\r\n  background-color: #eeeeee;\r\n}\r\n.sidebar.sidebar-default .sidebar-item > a.active {\r\n  color: #337ab7;\r\n  background-color: transprent;\r\n}\r\n.sidebar.sidebar-default .sidebar-item.sidebar-item-mini > a {\r\n  color: #464646;\r\n}\r\n.sidebar.sidebar-default .hammer-scrollbar {\r\n  background-color: #555;\r\n}\r\n.sidebar.sidebar-inverse {\r\n  color: #9d9d9d;\r\n  background-color: #2a3542;\r\n}\r\n.sidebar.sidebar-inverse .sidebar-group > span {\r\n  color: #46586e;\r\n  border-top-color: #344252;\r\n}\r\n.sidebar.sidebar-inverse .sidebar-group.sticky-header > span {\r\n  background-color: #2a3542;\r\n}\r\n.sidebar.sidebar-inverse .sidebar-group + .sidebar-item {\r\n  border-top-color: #344252;\r\n}\r\n.sidebar.sidebar-inverse .sidebar-divider-item {\r\n  border-top-color: #344252;\r\n}\r\n.sidebar.sidebar-inverse .sidebar-item > a {\r\n  color: #9d9d9d;\r\n  background-color: #2a3542;\r\n}\r\n.sidebar.sidebar-inverse .sidebar-item > a:hover,\r\n.sidebar.sidebar-inverse .sidebar-item > a:focus {\r\n  color: #fff;\r\n  background-color: #344252;\r\n}\r\n.sidebar.sidebar-inverse .sidebar-item > a.active {\r\n  color: #dfecf6;\r\n  background-color: #2a3542;\r\n}\r\n.sidebar.sidebar-inverse .sidebar-item.sidebar-item-mini > a {\r\n  color: #c1c1c1;\r\n}\r\n.sidebar.sidebar-inverse .hammer-scrollbar {\r\n  background-color: #e4e8ed;\r\n}\r\n.sidebar-obfuscator {\r\n  background-color: rgba(0, 0, 0, 0.5);\r\n}\r\n@media (min-width: 992px) {\r\n  .sidebar.sidebar-locked.sidebar-default {\r\n    border-color: #eeeeee;\r\n    max-width: 220px;\r\n  }\r\n  .sidebar.sidebar-locked.sidebar-inverse {\r\n    border-color: #344252;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
